import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import ComponentSettingsPage from '@/areas/settings/bom-components/OrganizationSettings/ComponentSettingsPage';
import { canViewDesignSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/settings/_menu/organization/component-settings')({
    staticData: {
        access: { permissions: canViewDesignSettings },
        chrome: 'home',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <ComponentSettingsPage />;
}
